import { axiosInstance } from ".."

const partnerleadlist = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/Partner/leadList?partnerId=${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default partnerleadlist;